// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAgsUR8abnlnNl4JXvnMPPt9q3IO4Xxq_Y",
    authDomain: "eduard-lache.firebaseapp.com",
    projectId: "eduard-lache",
    storageBucket: "eduard-lache.appspot.com",
    messagingSenderId: "764499841779",
    appId: "1:764499841779:web:606c33ba3178e5ea191d86",
    measurementId: "G-JDDXDLGEBF",
    databaseURL: "https://eduard-lache-default-rtdb.europe-west1.firebasedatabase.app"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
